export const frequency = [
  {
    value: 1,
    key: 'One-time',
    label: 'Only Once'
  },
  {
    value: 2,
    key: 'Weekly',
    label: 'Every Week'
  },
  {
    value: 3,
    key: 'Montly',
    label: 'Every Month',
  },
]

export const frequencySubscription = [
  {
    value: 2,
    key: 'Weekly',
    label: 'Every Week'
  },
  {
    value: 3,
    key: 'Montly',
    label: 'Every Month',
  },
]

export const getFrequencyLabelByValue = (value) => {
  if (!value) return
  for(let i = 0; i < frequency.length; i ++) {
    if (frequency[i].value*1 === value*1) {
      return frequency[i].label
    }
  }
}

export const getFrequencyKeyByValue = (value) => {
  if (!value) return
  for(let i = 0; i < frequency.length; i ++) {
    if (frequency[i].value*1 === value*1) {
      return frequency[i].key
    }
  }
}

export const getFrequencyList = () => {
  return frequency
}

export const getFrequencySubscriptionList = () => {
  return frequencySubscription
}